import { useCallback, useEffect, useState } from "react";
import { useDialog } from "../../../../../contexts/dialog";
import api, { BASE_URL, CancelToken } from "../../../../../services/api";

export type responseChannelProps = {
  data: {
    clipping_uri: string;
  };
};

type SquareProps = {
  name?: string;
};

type GetIframeSrcProps = {
  videoGroupData: {
    location: SquareProps;
    channel: SquareProps;
  };
  timeStamp: number;
  finalMixedDate: Date;
};

const GetIframeSrc = ({
  finalMixedDate,
  timeStamp,
  videoGroupData,
}: GetIframeSrcProps) => {
  const [iframeSrcs, setIframeSrcs] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const dialog = useDialog();

  const resetSrcs = () => setIframeSrcs({});

  useEffect(() => {
    if (videoGroupData.channel.name) {
      setIframeSrcs({}); // limpa o cache ao mudar de canal
    }
  }, [videoGroupData.channel.name]);

  const handleGetSrc = useCallback(
    async (locationName?: string, forceReload = false) => {
      if (!locationName) return;

      // Só faz chamada se não tiver cache ou se for forçado
      if (!forceReload && iframeSrcs[locationName]) return;

      setLoading(true);
      try {
        const source = CancelToken.source();

        const response: responseChannelProps = await api.get(
          `locations/${locationName}/channels/${videoGroupData.channel.name}`
        );

        const clippingSource = response.data.clipping_uri;
        const timeout = setTimeout(() => source.cancel(), 30000);

        const adjustTimeZoneOffsetToSaoPaulo = () => {
          const currentTimeZoneOffset =
            finalMixedDate.getTimezoneOffset() / 60 - 3;
          return finalMixedDate.getTime() - currentTimeZoneOffset * 60 * 60000;
        };

        const color =
          process.env.REACT_APP_CURRENT_APPLICATION === "GLOBO"
            ? "556cd6" // azul
            : "e94e15"; // laranja

        const iframeSourceResponse = await api.get(
          `${BASE_URL}${clippingSource}&datetime_from=${adjustTimeZoneOffsetToSaoPaulo()}&duration=${timeStamp}&autoplay=false&clock_reference=true&trim_controller=true&color=${color}`,
          {
            cancelToken: source.token,
          }
        );

        clearTimeout(timeout);

        setIframeSrcs((prevSrcs) => ({
          ...prevSrcs,
          [locationName]: iframeSourceResponse.data,
        }));
        //console.log('iframeSourceResponse: ', iframeSourceResponse.data)

        setLoading(false);
      } catch (err) {
        console.error(err);
        dialog.setDialogStatus(true);
        dialog.setDialogText("Ops! Não encontramos vídeos com estas seleções.");
        setLoading(false);

        throw err;
      }
    },
    [iframeSrcs, videoGroupData, timeStamp, finalMixedDate, dialog]
  );

  return { srcs: iframeSrcs, handleGetSrc, isLoading: loading, resetSrcs };
};

export default GetIframeSrc;
